import { IconProps } from './interfaces';

export const IconVideoPauseButton = ({ className }: IconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" className={className}>
            <path d="M8.16732 3.21289C6.87865 3.21289 5.83398 4.25756 5.83398 5.54622V22.453C5.83398 23.7417 6.87865 24.7864 8.16732 24.7864C9.45598 24.7864 10.5007 23.7417 10.5007 22.453V5.54622C10.5007 4.25756 9.45598 3.21289 8.16732 3.21289Z" />
            <path d="M19.834 3.21289C18.5453 3.21289 17.5007 4.25756 17.5007 5.54622V22.453C17.5007 23.7417 18.5453 24.7864 19.834 24.7864C21.1227 24.7864 22.1673 23.7417 22.1673 22.453V5.54622C22.1673 4.25756 21.1227 3.21289 19.834 3.21289Z" />
        </svg>
    );
};
